// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === SCHEDULING PAGE =============================================== */

.scheduling-page {
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  margin: 2rem auto;
  max-width: 960px;
  box-shadow: var(--shadow);
}

/* ---------- cabeçalho ---------- */
.scheduling-page .page-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.scheduling-page .page-header h1 {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-primary);
}

.scheduling-page .back-button {
  border: 1px solid var(--border-color);
  background-color: transparent;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-weight: 500;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  gap: 0.35rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.scheduling-page .back-button:hover {
  background-color: #f1f5f9;
}

/* ---------- grid principal ---------- */
.scheduling-content {
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 2rem;
}

/* ---------- cards de informação (paciente, médico, procedimentos) ---------- */
.info-card {
  background-color: #f8fafc;
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.info-card-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.75rem;
}

.info-card-content h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--primary-color);
  margin-bottom: 0.25rem;
}

.info-card-content p {
  font-size: 0.875rem;
  color: var(--text-secondary);
}

/* lista de procedimentos */
.procedures-list-summary {
  list-style: none;
  padding-left: 0;
  margin-bottom: 1rem;
}

.procedures-list-summary li {
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;
  border-bottom: 1px dashed var(--border-color);
  font-size: 0.875rem;
}

.procedure-price {
  font-weight: 600;
  color: var(--primary-color);
}

.total-price-container {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 1rem;
  border-top: 1px solid var(--border-color);
  padding-top: 0.75rem;
}

.total-price-value {
  color: var(--primary-color);
  font-size: 1.125rem;
}

/* ---------- formulário ---------- */
.scheduling-form {
  background-color: #f8fafc;
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  padding: 1.25rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.form-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.form-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.form-group {
  flex: 1 1;
  min-width: 160px;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.form-group label {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.875rem;
  color: var(--text-primary);
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 0.6rem 0.75rem;
  border: 1px solid var(--border-color);
  border-radius: 0.375rem;
  background-color: white;
  font-size: 0.9rem;
}

.form-group input.error,
.form-group select.error {
  border-color: var(--danger-color);
}

.error-message {
  font-size: 0.75rem;
  color: var(--danger-color);
}

/* textarea */
.comments-group textarea {
  resize: vertical;
}

/* nota info */
.scheduling-note {
  display: flex;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: var(--text-secondary);
  background-color: #f1f5f9;
  border: 1px solid var(--border-color);
  padding: 0.75rem 1rem;
  border-radius: 0.375rem;
}

/* ---------- ações do formulário ---------- */
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
}

.cancel-button,
.submit-button {
  padding: 0.75rem 1.5rem;
  border-radius: 0.375rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  border: none;
}

.cancel-button {
  background-color: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  transition: background-color 0.2s;
}

.cancel-button:hover {
  background-color: #f1f5f9;
}

.submit-button {
  background-color: var(--primary-color);
  color: white;
  transition: background-color 0.2s;
}

.submit-button:hover {
  background-color: var(--primary-hover);
}

/* ---------- responsividade ---------- */
@media (max-width: 768px) {
  .scheduling-content {
    grid-template-columns: 1fr;
  }

  .form-actions {
    flex-direction: column;
    gap: 0.75rem;
  }

  .form-actions button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/newPosConsult/css/rescheduleModal.css"],"names":[],"mappings":"AAAA,wEAAwE;;AAExE;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;AACX;;AAEA,gFAAgF;AAChF;EACE,yBAAyB;EACzB,qCAAqC;EACrC,qBAAqB;EACrB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,qCAAqC;EACrC,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;EAGE,uBAAuB;EACvB,qCAAqC;EACrC,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,qCAAqC;EACrC,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,yCAAyC;AACzC;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* === SCHEDULING PAGE =============================================== */\n\n.scheduling-page {\n  background-color: white;\n  border-radius: 8px;\n  padding: 2rem;\n  margin: 2rem auto;\n  max-width: 960px;\n  box-shadow: var(--shadow);\n}\n\n/* ---------- cabeçalho ---------- */\n.scheduling-page .page-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.scheduling-page .page-header h1 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.scheduling-page .back-button {\n  border: 1px solid var(--border-color);\n  background-color: transparent;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-weight: 500;\n  color: var(--text-secondary);\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.scheduling-page .back-button:hover {\n  background-color: #f1f5f9;\n}\n\n/* ---------- grid principal ---------- */\n.scheduling-content {\n  display: grid;\n  grid-template-columns: 1fr 360px;\n  gap: 2rem;\n}\n\n/* ---------- cards de informação (paciente, médico, procedimentos) ---------- */\n.info-card {\n  background-color: #f8fafc;\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.info-card-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 0.75rem;\n}\n\n.info-card-content h4 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--primary-color);\n  margin-bottom: 0.25rem;\n}\n\n.info-card-content p {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n/* lista de procedimentos */\n.procedures-list-summary {\n  list-style: none;\n  padding-left: 0;\n  margin-bottom: 1rem;\n}\n\n.procedures-list-summary li {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5rem 0;\n  border-bottom: 1px dashed var(--border-color);\n  font-size: 0.875rem;\n}\n\n.procedure-price {\n  font-weight: 600;\n  color: var(--primary-color);\n}\n\n.total-price-container {\n  display: flex;\n  justify-content: space-between;\n  font-weight: 600;\n  font-size: 1rem;\n  border-top: 1px solid var(--border-color);\n  padding-top: 0.75rem;\n}\n\n.total-price-value {\n  color: var(--primary-color);\n  font-size: 1.125rem;\n}\n\n/* ---------- formulário ---------- */\n.scheduling-form {\n  background-color: #f8fafc;\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  padding: 1.25rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.form-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 0.5rem;\n}\n\n.form-row {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.form-group {\n  flex: 1;\n  min-width: 160px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.form-group label {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.875rem;\n  color: var(--text-primary);\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 0.6rem 0.75rem;\n  border: 1px solid var(--border-color);\n  border-radius: 0.375rem;\n  background-color: white;\n  font-size: 0.9rem;\n}\n\n.form-group input.error,\n.form-group select.error {\n  border-color: var(--danger-color);\n}\n\n.error-message {\n  font-size: 0.75rem;\n  color: var(--danger-color);\n}\n\n/* textarea */\n.comments-group textarea {\n  resize: vertical;\n}\n\n/* nota info */\n.scheduling-note {\n  display: flex;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  background-color: #f1f5f9;\n  border: 1px solid var(--border-color);\n  padding: 0.75rem 1rem;\n  border-radius: 0.375rem;\n}\n\n/* ---------- ações do formulário ---------- */\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.cancel-button,\n.submit-button {\n  padding: 0.75rem 1.5rem;\n  border-radius: 0.375rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  cursor: pointer;\n  border: none;\n}\n\n.cancel-button {\n  background-color: transparent;\n  color: var(--text-secondary);\n  border: 1px solid var(--border-color);\n  transition: background-color 0.2s;\n}\n\n.cancel-button:hover {\n  background-color: #f1f5f9;\n}\n\n.submit-button {\n  background-color: var(--primary-color);\n  color: white;\n  transition: background-color 0.2s;\n}\n\n.submit-button:hover {\n  background-color: var(--primary-hover);\n}\n\n/* ---------- responsividade ---------- */\n@media (max-width: 768px) {\n  .scheduling-content {\n    grid-template-columns: 1fr;\n  }\n\n  .form-actions {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .form-actions button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
